import ChipButton from 'components/ChipButton'
import Pagination from 'components/Pagination'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FetchContext } from '../../../contexts/FetchContext'

function ResultView({ children, ...props }) {
  const { t } = useTranslation()
  const [hits, setHits] = useState(10)

  const { resultList } = useContext(FetchContext)

  const { documents = [], stats = { totalHits: null }, activeSearcher } = props

  const _handlePagination = () => {
    const nextHits = hits + 10
    setHits(nextHits)
  }

  useEffect(() => {
    setHits(10)
  }, [activeSearcher])

  return (
    <div className="layout layout--padding-bottom layout--padding-top u-min-height-screen">
      <div
        className="layout__container layout__container--dynamic"
        style={{ height: 'inherit' }}
      >
        <div className="row layout__inner">
          {children}
          <Pagination>
            {resultList.length < stats.totalHits && (
              <ChipButton
                label={t('Visa fler')}
                selected
                onClick={_handlePagination}
              />
            )}
          </Pagination>
        </div>
      </div>
    </div>
  )
}

export default ResultView
